import IntercomWindow from './IntercomWindow';

export default IntercomWindow;
